export const models = "/model/find-all";
export const addModels = "/model/create";
export const deleteModelById = "/model/delete/";
export const updateModelById = "/model/update/";
